import { maxWidth } from '@/assets/styles/mixins.css.js'
import styled, { css } from 'styled-components'
import vars from '@/assets/styles/vars'
import Button from './StyledButton'

const Section = styled.section`
  &:last-child {
    padding-bottom: 110px;

    ${maxWidth(vars.breakpoints.tablet)`
      padding-bottom: 100px;
    `}

    ${maxWidth(vars.breakpoints.lMobile)`
      padding-bottom: 64px;
    `}
  }

  ${props =>
    props.overflowHidden &&
    css`
      overflow: hidden;
    `}

  ${props =>
    props.contentTabletFull &&
    css`
      overflow: hidden;
      width: calc(100% + ${vars.container.spaceTablet}px * 2);
      margin-left: -${vars.container.spaceTablet}px;
      padding-left: ${vars.container.spaceTablet}px;
      padding-right: ${vars.container.spaceTablet}px;

      ${maxWidth(vars.breakpoints.mobile)`
        width: calc(100% + ${vars.container.spaceMobile}px * 2);
        margin-left: -${vars.container.spaceMobile}px;
        padding-left: ${vars.container.spaceMobile}px;
        padding-right: ${vars.container.spaceMobile}px;
      `}
    `}

  ${({ pt }) => {
    switch (pt) {
      case 'x-large':
        return css`
          padding-top: 120px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-top: 100px;
          `}

          ${maxWidth(vars.breakpoints.lMobile)`
            padding-top: 60px;
          `}
        `
        case 'm-large':
          return css`
            padding-top: 90px;
  
            ${maxWidth(vars.breakpoints.tablet)`
              padding-top: 56px;
            `}
  
          `
      case 'large':
        return css`
          padding-top: 80px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-top: 56px;
          `}

          ${maxWidth(vars.breakpoints.lMobile)`
            padding-top: 40px;
          `}
        `
      case 'none':
        return css`
          padding-top: 0;
        `
      case 'medium':
      default:
        return css`
          padding-top: 110px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-top: 60px;
          `}
        `
    }
  }}

  ${({ pb }) => {
    switch (pb) {
      case 'x-large':
        return css`
          padding-bottom: 120px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-bottom: 100px;
          `}

          ${maxWidth(vars.breakpoints.lMobile)`
            padding-bottom: 60px;
          `}
        `
      case 'large':
        return css`
          padding-bottom: 80px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-bottom: 56px;
          `}

          ${maxWidth(vars.breakpoints.lMobile)`
            padding-bottom: 48px;
          `}
        `

        case 'small':
          return css`
            padding-bottom: 60px;
  
            ${maxWidth(vars.breakpoints.tablet)`
              padding-bottom: 50px;
            `}
          `
        case 'x-small':
          return css`
            padding-bottom: 30px;
  
            ${maxWidth(vars.breakpoints.tablet)`
              padding-bottom: 30px;
            `}
          `
      case 'none':
        return css`
          padding-bottom: 0;

          &:last-child {
            padding-bottom: 0;
          }
        `
      case 'medium':
      default:
        return css`
          padding-bottom: 110px;

          ${maxWidth(vars.breakpoints.tablet)`
            padding-bottom: 60px;
          `}
        `
    }
  }}

  ${props =>
    props.backgroundDecor &&
    css`
      background-color: var(--color-bg-accent);
      background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE3NCIgaGVpZ2h0PSI1OTIiIHZpZXdCb3g9IjAgMzIgMTE3NCA1OTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZGQpIj48cGF0aCBkPSJNMzM1LjU1NiA0MDMuNzE1QzIwMS40NjIgMzM3LjMzNiAzMiAzNDcuNzg3IDMyIDMyaDU4NC4yMDdjMCAxNDUuNDY2IDEwMS4xMTkgMjUwLjYwNCAyNTcuMzU2IDI3NC40MzRDOTk4LjY5OCAzMjUuNTIxIDEwOTQuNjIgNTAxLjQ0MiAxMTQxLjA5IDYyNEg1MTAuNjA2Yy0zMC4wNTktNTkuNDU1LTgyLjczNi0xNzQuNTg4LTE3NS4wNS0yMjAuMjg1eiIgZmlsbD0iI0Y5RkFGQiIvPjwvZz48ZGVmcz48ZmlsdGVyIGlkPSJmaWx0ZXIxX2RkIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTE3My4wOSIgaGVpZ2h0PSI2NTYiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj48ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPjxmZU9mZnNldC8+PGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMTYiLz48ZmVDb2xvck1hdHJpeCB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMDIgMCIvPjxmZUJsZW5kIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPjxmZUNvbG9yTWF0cml4IGluPSJTb3VyY2VBbHBoYSIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIvPjxmZU9mZnNldC8+PGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMiIvPjxmZUNvbG9yTWF0cml4IHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4wMyAwIi8+PGZlQmxlbmQgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3ciIHJlc3VsdD0iZWZmZWN0Ml9kcm9wU2hhZG93Ii8+PGZlQmxlbmQgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0Ml9kcm9wU2hhZG93IiByZXN1bHQ9InNoYXBlIi8+PC9maWx0ZXI+PC9kZWZzPjwvc3ZnPg==');
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center center;

      ${maxWidth(vars.breakpoints.tablet)`
        background-image: none;
      `}
    `}


  ${props =>
    props.backgroundColor &&
    css`
      background: #f8f8f8;
    `}

  ${props =>
      props.mobOrder &&
      css`
        ${maxWidth(vars.breakpoints.tablet)`
          order: ${props.mobOrder};
        `}
      `}
  
  ${props =>
      props.pbMob &&
      css`
        ${maxWidth(vars.breakpoints.tablet)`
          padding-bottom: 60px;
        `}
      `}
`

Section.Header = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  & > *:first-child {
    margin-right: auto;
  }

  ${Button} {
    margin-bottom: 24px;
    cursor: auto;
  }
`

export default Section
